import { loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm, monitoringOff, monitoringOn } from '@assets/images/main/index';
import {
  Icon3d3d,
  Icon3dAlert,
  Icon3dCheck,
  Icon3dCycle,
  Icon3dDetect,
  Icon3dLocation,
  Icon3dMap2,
  Icon3dMeter,
  Icon3dSchedule,
  Icon3dServer,
  IconDownload,
} from '@assets/images/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  iotBannerBg,
  iotBannerProduct,
  iotScreenshot1D,
  iotScreenshot1M,
  iotScreenshot1T,
  iotScreenshot2D,
  iotScreenshot2M,
  iotScreenshot2T,
  iotScreenshot3D,
  iotScreenshot3M,
  iotScreenshot3T,
} from '@assets/images/main/sensor';
import { IconAirQualityInv, IconBellInv, IconCo2Inv, IconLoraSensorInv } from '@assets/images/main/icon';
import { screenViewIot1, screenViewIot2, screenViewIot3, screenViewIot4 } from '@assets/images/main/screenView';

import IconAirOff from '@assets/images/main/screenView/iot/airIcon.png';
import IconFireOff from '@assets/images/main/screenView/iot/fireIcon.png';
import IconRobotOff from '@assets/images/main/screenView/iot/robotIcon.png';
import IconJetpanOff from '@assets/images/main/screenView/iot/jetpanIcon.png';
import IconAirOn from '@assets/images/main/screenView/iot/airIconOn.png';
import IconFireOn from '@assets/images/main/screenView/iot/fireIconOn.png';
import IconRobotOn from '@assets/images/main/screenView/iot/robotIconOn.png';
import IconJetpanOn from '@assets/images/main/screenView/iot/jetpanIconOn.png';

export default {
  banner: {
    title: '无论是复杂设备，还是多样数据，<br/>在 ORBRO 中都可统一运作。',
    desc: '温湿度、空气质量、压力、二氧化碳、入侵检测、电力控制、紧急按钮等<br/>现场 IoT 数据将实时收集并在 ORBRO OS 中可视化。',

    schemeTitle: '为工业现场量身定制的传感器，ORBRO 已为您准备好',
    bgImg: iotBannerBg,
    productImg: iotBannerProduct,
  },

  func: {
    title: '查看更多功能',
    desc: '了解传感器的多种功能。',

    data: [
      {
        img: Icon3dMap2,
        title: '实时监控传感器状态',
        desc: '可在 ORBRO OS 上实时查看传感器的工作状态、电量以及信号强度。',
      },
      {
        img: Icon3dCheck,
        title: '基于地图的传感器分布查看',
        desc: '将传感器的安装位置可视化显示在地图或平面图上，便于查看各区域状态。',
      },
      {
        img: Icon3dSchedule,
        title: '事件记录与通知日志查看',
        desc: '可通过时间轴查看异常事件与通知记录，并用于后续原因分析。',
      },
      {
        img: Icon3dLocation,
        title: '按区域管理传感器分组',
        desc: '根据安装区域或用途对传感器进行分组，在仪表盘中直观管理。',
      },
      {
        img: Icon3dAlert,
        title: '异常检测与阈值设置',
        desc: '可为每个传感器设定阈值，超过时系统将自动检测并发送通知。',
      },
      {
        img: Icon3dAlert,
        title: '按区域设置不同通知条件',
        desc: '对于高风险区域可设置更敏感的通知条件，实现区域级别的灵敏度控制。',
      },
      {
        img: IconDownload,
        title: '数据记录保存与导出',
        desc: '测量数据与事件记录将自动保存，并支持导出为 CSV 或 Excel 文件。',
      },
      {
        img: Icon3dServer,
        title: '外部系统对接（API）',
        desc: '提供 API 接口，可与门禁控制、设备控制等外部系统灵活集成，并支持事件触发自动化操作。',
      },
    ],
  },

  bannerData: [
    {
      icon: loraSensorOn,
      iconInv: IconLoraSensorInv,
      iconOff: loraSensorOff,
      image: '',
      iconText: 'LoRA 传感器',
      sub: 'New',
      link: '/cn/iot/LoRASensor',
    },
    {
      icon: coOn,
      iconInv: IconCo2Inv,
      iconOff: coOff,
      image: '',
      iconText: 'CO₂ 检测仪',
      sub: 'New',
      link: '/cn/iot/co2',
    },
    {
      icon: airOn,
      iconInv: IconAirQualityInv,
      iconOff: airOff,
      image: '',
      iconText: '空气质量监测器',
      sub: 'New',
      link: '/cn/iot/air',
    },
    {
      icon: monitoringOn,
      iconInv: IconBellInv,
      iconOff: monitoringOff,
      image: '',
      iconText: '紧急按钮',
      sub: '',
      link: '/cn/iot/bell',
    },
  ],
  screenView: {
    title: '多种传感器，通过集成实现扩展',
    data: [
      { icon: IconAirOff, iconOn: IconAirOn, text: '空气质量传感器监控', img: screenViewIot1 },
      { icon: IconFireOff, iconOn: IconFireOn, text: '与火灾报警器联动', img: screenViewIot2 },
      { icon: IconAirOff, iconOn: IconAirOn, text: '与配送机器人联动', img: screenViewIot3 },
      { icon: IconAirOff, iconOn: IconAirOn, text: '与喷射风扇联动', img: screenViewIot4 },
    ],
  },
  screenShot: [
    {
      title: '实时查看所有传感器的统一仪表盘',
      desc: 'ORBRO OS 实时可视化各种 IoT 传感器数据，<br/>在一个界面上直观管理位置信息与传感器状态。',
      img: {
        desktop: iotScreenshot1D,
        tablet: iotScreenshot1T,
        mobile: iotScreenshot1M,
      },
    },
    {
      title: '显示时间变化的传感器数据图表',
      desc: '通过时间段图表查看各传感器测量数据，快速发现环境变化与异常趋势。',
      img: {
        desktop: iotScreenshot2D,
        tablet: iotScreenshot2T,
        mobile: iotScreenshot2M,
      },
    },
    {
      title: '检测到异常即刻推送通知，快速响应',
      desc: '传感器检测到超出阈值或异常状态时，ORBRO OS 将立即向管理员发送通知，帮助快速应对。',
      img: {
        desktop: iotScreenshot3D,
        tablet: iotScreenshot3T,
        mobile: iotScreenshot3M,
      },
    },
  ],

  FAQ: [
    {
      title: '传感器数据多久更新一次？',
      description: '默认间隔为 1~5 分钟，部分传感器支持实时传输。',
    },
    {
      title: '在离线环境下可以运行吗？',
      description: '部分传感器支持本地存储，在网络恢复后上传数据。',
    },
    {
      title: '可以同时安装多个传感器吗？',
      description: 'ORBRO OS 可同时连接和管理多个传感器。',
    },
    {
      title: '能与外部设备对接吗？',
      description: '可通过 API 与门禁、控制系统等多种设备灵活集成。',
    },
    {
      title: '传感器的电池能用多久？',
      description: '依产品而定，LoRa 传感器平均可使用 6 个月至 1 年以上，并可实时监测电量。',
    },
    {
      title: '所有传感器都能接入 ORBRO OS 吗？',
      description: 'ORBRO 认证产品可自动接入，支持部分使用 Modbus、RS-485 协议的第三方传感器。',
    },
    {
      title: '传感器异常时会通知吗？',
      description: '会的。系统会自动检测断线、低电量等异常情况并发送通知。',
    },
    {
      title: '可以多人同时接收通知吗？',
      description: '可以。支持按部门或角色设定接收通知的用户组。',
    },
  ],
};
